import type { StripeConnectStatus } from "shared/types/integrations";
import { axiosClient } from "utilz";

const BASE_URL = import.meta.env.VITE_APP_INTEGRATION_BASE_URL;

export const connectStripe = async () => {
  const frontendUrl = `${window.location.origin}/app/control-center/integrations/stripe/success`;
  const url = `${BASE_URL}/v1/stripe/connect?frontendUrl=${encodeURIComponent(
    frontendUrl,
  )}`;
  // const url = `${BASE_URL}/v1/stripe/connect?frontendUrl=${frontendUrl}`;
  const response = await axiosClient.get(url);

  const resData = response.data;
  if (resData && resData.statusCode === 200) {
    return resData.data as { uri: string };
  }
  throw new Error(resData?.message);
};

export const getStripeConnectStatus = async () => {
  const url = `${BASE_URL}/v1/stripe/connect/status`;
  const response = await axiosClient.get(url);
  const resData = response.data;
  if (resData && resData.statusCode === 200) {
    return resData.data as StripeConnectStatus;
  }
  throw new Error(resData?.message);
};

export const disconnectStripe = async () => {
  const url = `${BASE_URL}/v1/stripe/disconnect`;
  const response = await axiosClient.post(url);
  const resData = response.data;
  if (resData && resData.statusCode === 200) {
    return resData.data;
  }
  throw new Error(resData?.message);
};

export const updateStripeStatus = async (status: boolean) => {
  const url = `${BASE_URL}/v1/stripe/msp/configuration/status/${status}`;
  const response = await axiosClient.patch(url);
  const resData = response.data;
  if (resData && resData.statusCode === 200) {
    return resData.data;
  }
  throw new Error(resData?.message);
};
